import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import { Autocomplete, CollapseCard } from '@totalsoft/rocket-ui';
import { get } from '@totalsoft/change-tracking-react';
import { useTranslation } from 'react-i18next';
import { emptyArray } from 'constants/defaultValues';
import { valueOrDefault } from 'utils/functions';
import { useMemo } from 'react';
import { useCallback } from 'react';

const RisksComponent = ({ risks, onRiskSelectionChange, cardIconColor, disabled }) => {
  const { t } = useTranslation();

  const selectedIds = useMemo(
    () => risks.filter(risk => risk.selected |> get).map(selectedRisks => selectedRisks.quotationRiskId |> get),
    [risks]
  );

  const handleChange = useCallback(
    selectedRisks => {
      const newSelectedIds = selectedRisks.map(x => x.quotationRiskId);
      if (newSelectedIds.length > selectedIds.length) {
        const newId = newSelectedIds.find(x => !selectedIds.includes(x));
        if (newId) onRiskSelectionChange(newId)(true);
      } else {
        const oldId = selectedIds.find(x => !newSelectedIds.includes(x));
        if (oldId) onRiskSelectionChange(oldId)(false);
      }
    },
    [selectedIds, onRiskSelectionChange]
  );

  return (
    <CollapseCard
      iconColor={cardIconColor}
      icon={PlaylistAddCheckIcon}
      title={t('Offer.Edit.Casco.Risks.Title')}
      sx={{ mb: 1 }}
      toggleOnHeaderClick
    >
      <Grid item xs={12} md={12} lg={12}>
        {risks && risks.length > 0 ? (
          <Autocomplete
            isMultiSelection
            isSearchable
            fullWidth
            options={
              risks.map(risk => ({
                ...(risk |> get),
                isDisabled: (risk.readOnly |> get) || (risk.mandatory |> get)
              })) |> valueOrDefault(emptyArray)
            }
            simpleValue
            onChange={selectedRisks => handleChange(selectedRisks)}
            valueKey='quotationRiskId'
            labelKey='riskName'
            value={selectedIds}
            disabled={disabled}
          />
        ) : (
          <Grid container justifyContent='center'>
            {t('Offer.Edit.Casco.Risks.EmptyList')}
          </Grid>
        )}
      </Grid>
    </CollapseCard>
  );
};

RisksComponent.propTypes = {
  risks: PropTypes.array,
  onRiskSelectionChange: PropTypes.func,
  cardIconColor: PropTypes.string,
  disabled: PropTypes.bool
};

export default RisksComponent;
